import { Select, Form } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

// wrapper component for <Select /> where dropdown menu is scrolled along with page scroll
const SelectPopupContainer = ({ label, id, children, ...rest }) => {
  return (
    <Form.Item label={label} colon={false} style={{ position: 'relative' }} className={id}>
      <Select
        suffixIcon={<CaretDownOutlined color="red" />}
        getPopupContainer={() => document.querySelector(`.${id}`)}
        {...rest}>
        {children}
      </Select>
    </Form.Item>
  );
};

SelectPopupContainer.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
};

export default SelectPopupContainer;
